/* eslint-disable @typescript-eslint/naming-convention */
import { CustomImage, Font } from './style';

export enum FrontDynamicThemesCSS {
  DEFAULT = 'default',
  ALTERNATIVE = 'alternative',
  TEACHERS = 'teachers',
  OVF = 'OVF',
  HDF = 'HDF',
  DEFFINUM = 'deffinum',
  LAPOSTE = 'laposte',
}

export const FrontDynamicThemesCSSFiles = {
  ALTERNATIVE: {
    theme: FrontDynamicThemesCSS.ALTERNATIVE,
    files: ['alternative_1'],
  },
  TEACHERS: {
    theme: FrontDynamicThemesCSS.TEACHERS,
    files: ['teachers_1'],
  },
  OVF: {
    theme: FrontDynamicThemesCSS.OVF,
    files: ['ovf_1'],
  },
  HDF: {
    theme: FrontDynamicThemesCSS.HDF,
    files: ['hdf_1'],
  },
  DEFFINUM: {
    theme: FrontDynamicThemesCSS.DEFFINUM,
    files: ['deffinum_1'],
  },
  LAPOSTE: {
    theme: FrontDynamicThemesCSS.LAPOSTE,
    files: ['laposte_1'],
  },
};

export enum IconGroups {
  LINEAR = 'linear',
  FILLED = 'filled',
}

export const IconGroupsPrefixes: IconGroupWithPrefix[] = [
  {
    group: IconGroups.LINEAR,
    prefix: 'linear-',
  },
  {
    group: IconGroups.FILLED,
    prefix: 'filled-',
  },
];

export interface IconGroupWithPrefix {
  group: IconGroups;
  prefix: string;
}

export const themingPropertiesOvf = Object.freeze([
  { key: 'primary', cssVar: '--ovf-primary' },
  { key: 'primaryLight', cssVar: '--ovf-primary-light' },
  { key: 'primaryDark', cssVar: '--ovf-primary-dark' },
  { key: 'primary', cssVar: '--primary' },
  { key: 'primaryLight', cssVar: '--primary-light' },
  { key: 'primaryDark', cssVar: '--primary-dark' },
  { key: 'white', cssVar: '--white' },
  { key: 'dark', cssVar: '--dark' },
  { key: 'navy', cssVar: '--navy' },
  { key: 'gray', cssVar: '--gray' },
  { key: 'progress', cssVar: '--progress' },
  { key: 'pending', cssVar: '--pending' },
  { key: 'done', cssVar: '--done' },
  { key: 'titleFont', cssVar: '--title-font', value: (v: Font): string => v.cssName },
  { key: 'mainFont', cssVar: '--main-font', value: (v: Font): string => v.cssName },
  { key: 'backgroundHome', cssVar: '--background-home', value: (v: CustomImage): string => v.src },
  { key: 'backgroundStats', cssVar: '--background-stats', value: (v: CustomImage): string => v.src },
]);
